// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProtocolVisit } from './protocol-visit';
import {
    ProtocolVisitFromJSON,
    ProtocolVisitFromJSONTyped,
    ProtocolVisitToJSON,
    ProtocolVisitToJSONTyped,
} from './protocol-visit';

/**
 * 
 * @export
 * @interface ProtocolPeriod
 */
export interface ProtocolPeriod {
    /**
     * 
     * @type {string}
     * @memberof ProtocolPeriod
     */
    name: string;
    /**
     * 
     * @type {Array<ProtocolVisit>}
     * @memberof ProtocolPeriod
     */
    visits: Array<ProtocolVisit>;
}

/**
 * Check if a given object implements the ProtocolPeriod interface.
 */
export function instanceOfProtocolPeriod(value: object): value is ProtocolPeriod {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('visits' in value) || value['visits'] === undefined) return false;
    return true;
}

export function ProtocolPeriodFromJSON(json: any): ProtocolPeriod {
    return ProtocolPeriodFromJSONTyped(json, false);
}

export function ProtocolPeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProtocolPeriod {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'visits': ((json['visits'] as Array<any>).map(ProtocolVisitFromJSON)),
    };
}

export function ProtocolPeriodToJSON(json: any): ProtocolPeriod {
    return ProtocolPeriodToJSONTyped(json, false);
}

export function ProtocolPeriodToJSONTyped(value?: ProtocolPeriod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'visits': ((value['visits'] as Array<any>).map(ProtocolVisitToJSON)),
    };
}
